// Copyright (c) 2021 WiseTime. All rights reserved.

import { PostTimeGroup, PostTimeRequest, TimeGroup } from "../../generated/wisetime/user/timeline/v4/timeline_pb"
import { SiteRef } from "../../generated/wisetime/type/site_ref_pb"
import { TagRef } from "../../generated/wisetime/user/type/tag_ref_pb"
import { ActivityTypeRef } from "../../generated/wisetime/user/type/activity_type_ref_pb"
import { Duration } from "../../generated/google/protobuf/duration_pb"
import { hoursToSecondsRounded, secondsToHoursRounded } from "./timeGroups"
import { RoundingPreference } from "../../generated/wisetime/type/site_preferences_pb"

export const roundedTotalDuration = (seconds: number, roundingPreference: RoundingPreference): number =>
  hoursToSecondsRounded(secondsToHoursRounded(seconds, roundingPreference).toString())

export const buildPostTimeRequest = (
  timeGroup: TimeGroup.AsObject,
  currentSiteRef: SiteRef.AsObject,
  roundingPreference: RoundingPreference,
): PostTimeRequest => {
  const activityType = timeGroup.activityTypesList.find(activityType => activityType.siteId === currentSiteRef.id)
  const request = new PostTimeRequest()
    .setSite(
      new SiteRef()
        .setId(currentSiteRef.id)
        .setDisplayName(currentSiteRef.displayName)
    )
    .setTimeGroupsList([
      new PostTimeGroup()
        .setTimeGroupId(timeGroup.id)
        .setTagsList(timeGroup.tagsList
          .filter(tag => tag.siteId === currentSiteRef.id)
          .map(tag => new TagRef().setId(tag.id).setSiteId(tag.siteId).setName(tag.name))
        )
        .setActivityType(
          activityType && (
            new ActivityTypeRef()
              .setId(activityType.id)
              .setSiteId(activityType.siteId)
              .setLabel(activityType.label)
          )
        )
        .setTotalDuration(
          new Duration()
            .setSeconds(timeGroup.totalDuration?.seconds ?? 0)
            .setNanos(timeGroup.totalDuration?.nanos ?? 0)
        )
        .setRoundedTotalDuration(
          new Duration().setSeconds(roundedTotalDuration(timeGroup.totalDuration?.seconds ?? 0, roundingPreference))
        )
    ])
  return request
}
